import { Injectable, Signal, computed, inject } from '@angular/core';
import { CalGtmService, ICalGtmBaseEvent, ICalGtmEventDictionary, TCalGtmAuditRequestEvent } from '@cal-analytics/gtm';
import { GtmAdapterService } from './gtm-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class GtmPartnersService extends CalGtmService {
  override auditRequest: Signal<ICalGtmEventDictionary<Partial<TCalGtmAuditRequestEvent>>>;
  override baseEvent = computed(() => ({}));
  override funnelClick = computed(() => ({}));
  override funnelStep = computed(() => ({}));
  override questionFilled = computed(() => ({}));
  override questionValidation = computed(() => ({}));
  override checkboxClick = computed(() => ({}));
  override funnelEnd = computed(() => ({}));
  override formSent = computed(() => ({}));

  override getBaseEvent(): ICalGtmBaseEvent {
    throw new Error('Method not implemented.');
  }

  private gtmAdapter = inject(GtmAdapterService);

  baseEvent$$ = computed(() => {
    return this.gtmAdapter.baseEventGetter();
  });

  baseFunnelStep$$ = computed(() => {
    return this.gtmAdapter.funnelStepGetter();
  });

  baseFunnelEnd$$ = computed(() => {
    return this.gtmAdapter.funnelEndGetter();
  });

  isNewOrUnknownCustomerType(customerType?: number): boolean {
    return this.gtmAdapter.isNewOrUnknownCustomerType(customerType);
  }

  isExistCustomerType(customerType?: number): boolean {
    return this.gtmAdapter.isExistCustomerType(customerType);
  }
  
  isVerifiedCustomer() {
    return this.gtmAdapter.getCustomerTypeData().isVerifiedCustomer;
  }
}
